import React from 'react'
import styles from './ChooseDeviceStep.scss'
import { S2DLayout } from '../S2DLayout'
import { RadioButtonGroup } from 'common/styleguide/RadioGroup'
import { Msg, useFormatMessage, featureNames } from 'lib/localization'
import { OrderedMap } from 'immutable'
import cx from 'classnames'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const messages = defineMessages({
  tip: {
    id: 's2d.tip',
    defaultMessage: 'Please choose a device to continue'
  }
})

export const devices = OrderedMap({
  iphone: 'iPhone',
  android: 'Android',
  garmin: 'Garmin Edge',
  wahoo: 'Wahoo'
})

export const ChooseDeviceStep = ({
  route, routeId, subtitle, selectedDevice, onChangeDevice, onConfirmDevice
}) => {
  const fm = useFormatMessage()
  return (
    <S2DLayout
      title={<Msg m={featureNames.sendToDevice} />}
      subtitle={subtitle}
      step={1}
      onClickNext={() => onConfirmDevice()}
      disableNext={!selectedDevice && fm(messages.tip)}>
      <div className={styles.ChooseDeviceStep}>
        <div className={styles.columns}>
          <div className={cx(styles.column, styles.mapCol)}>
            <RenderedStaticMap route={route} routeId={routeId} />
          </div>
          <div className={styles.column}>
            <p><T id='s2d.selectADevice' defaultMessage='Select a device' /></p>
            <RadioButtonGroup
              selected={selectedDevice}
              options={devices}
              onChange={onChangeDevice} />
            <div>
              <T
                id='s2d.orOther'
                defaultMessage='or <a>Other Device</a>'
                values={{ a: (...c) => <a onClick={() => onConfirmDevice('other')}>{c}</a> }} />
            </div>
          </div>
        </div>
      </div>
    </S2DLayout>
  )
}

const RenderedStaticMap = ({ routeId, route }) => (
  <div className={styles.RenderedStaticMap}>
    <img className={styles.mapImg} src={`/routes/light/${routeId}.png`} />
    <div className={styles.scrim}>
      <div className={styles.label}>
        <div className={styles.routeName}>{route && route.name}</div>
        <div className={styles.routeAuthor}>{route && route.user.name}</div>
      </div>
    </div>
  </div>
)
